import { Card, CardBody, Col, Container, Row } from "reactstrap";
 import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import CommonDropDown from "../../common/CommonDropDown";
 import TaxInfoCountry from "./TaxInfoCountry";
import NavigationBreadcrumbs from "../../../common-elements/breadcrumbs/NavigationBreadcrumbs";
import CardHeaderCommon from "../../../common-elements/card-header-common/CardHeaderCommon";

function TaxListCountryData() {
  const { t } = useTranslation();
  const { countryName } = useParams();
  const navigate = useNavigate();

  const oHandleClickHistory = (countryName: string) => {
    navigate(
      `${process.env.PUBLIC_URL}/tax-types/country/${encodeURIComponent(
        countryName
      )}/history`
    );
  };

  const breadcrumbLinks = [
    {
      label: "Tax Types",
      url: `${process.env.PUBLIC_URL}/masterdata/tax-types`,
    },
    { label: t(countryName || "India"), active: true },
  ];

  return (
    <>
      <NavigationBreadcrumbs
        mainTitle={t("TaxTypes")}
        parent={t("Master Data")}
        links={breadcrumbLinks}
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="list-product-header">
                  <div className="header-container">
                    <div className="search-container"  style={{ marginTop: '-15px' }}>
                      <CardHeaderCommon
                        title={`${countryName} ${t("TaxTypes")}`}
                      />
                    </div>

                    <div className="actions-container">
                      <Link
                        className="btn btn-primary"
                        to={`${
                          process.env.PUBLIC_URL
                        }/masterdata/add-tax-type?country=${encodeURIComponent(
                          countryName || ""
                        )}`}
                      >
                        <i className="fa fa-plus" />
                        {t("AddTaxTypes")}
                      </Link>
                      <button
                        className="btn btn-warning"
                        onClick={() => oHandleClickHistory(countryName || "")}
                      >
                        <i className="fa fa-history me-2" />
                        {t("History")}
                      </button>
                      <CommonDropDown color="info" />
                    </div>
                  </div>
                </div>
                <TaxInfoCountry />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TaxListCountryData;
